import { Download } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function Revit(props) {
  const { t } = useTranslation();

  const files = [
    {
      name: t("Installer2024"),
      description: t("Installer2024"),
      url: "/files/KeyProSuite2024.zip",
    },
    {
      name: t("RevitManual"),
      description: t("RevitManualDescription"),
      url: "/files/Manual.zip",
    },
  ];

  return (
    <form className="max-w-fit">
      <div className="w-full p-12">
        <h2 className="text-2xl font-bold mb-6">{t("Revit")}</h2>
        <div className="space-y-4">
          {files.map((file) => (
            <div key={file.name} className="border rounded-lg p-4 hover:bg-gray-50 transition-colors">
              <div className="mb-2">
                <p className="text-gray-600">{file.description}</p>
              </div>
              <a href={file.url} className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium">
                <Download className="w-4 h-4 mr-2" />
                Download {file.name}
              </a>
            </div>
          ))}
        </div>
      </div>
    </form>
  );
}
